import React from "react";
import ContentPage, { Block, CardGrid } from "../components/ContentPage";

const CATEGORIES = [
  {
    title: "Boodschappen",
    body: "Bestel dagelijkse producten zoals rijst, olie, meel, dranken, conserven, snacks en andere levensmiddelen.",
  },
  {
    title: "Huishoudelijke producten",
    body: "Van schoonmaakmiddelen en wasproducten tot keuken- en huishoudelijke benodigdheden.",
  },
  {
    title: "Persoonlijke verzorging",
    body: "Bestel verzorgingsproducten voor volwassenen, kinderen, baby's en ouderen.",
  },
  {
    title: "Baby- en kinderproducten",
    body: "Help jonge gezinnen met luiers, babyverzorging, voeding en andere benodigdheden.",
  },
  {
    title: "Schoolbenodigdheden",
    body: "Ondersteun kinderen en studenten met schoolspullen, tassen, schrijfwaren en andere producten.",
  },
  {
    title: "Cadeaus en verrassingen",
    body: "Maak een verjaardag of speciale gelegenheid bijzonder met een cadeau, bloemen, taart of verrassingspakket.",
  },
];

export default function ProductenPage() {
  return (
    <ContentPage
      title="Alles voor het dagelijks leven"
      lead="Van boodschappen tot cadeaus — bestel wat je familie en vrienden in Suriname nodig hebben."
      ctaLabel="Bekijk in de app"
      secondaryLabel="Familiepakketten"
      secondaryTo="/pakketten"
    >
      <CardGrid items={CATEGORIES} />

      <Block title="Voor familie en vrienden in Suriname">
        <p>
          Suriwebwinkel is er voor iedereen die vanuit het buitenland iets wil
          betekenen voor iemand in Suriname.
        </p>
        <CardGrid
          items={[
            {
              title: "Voor je ouders",
              body: "Bestel boodschappen, verzorgingsproducten en huishoudelijke benodigdheden voor je moeder, vader, opa of oma.",
            },
            {
              title: "Voor je kinderen en familie",
              body: "Help met producten voor school, het huishouden, persoonlijke verzorging of andere dagelijkse behoeften.",
            },
            {
              title: "Voor vrienden en kennissen",
              body: "Verras iemand met een cadeau, bloemen, lekkernijen of een persoonlijk samengesteld pakket.",
            },
            {
              title: "Voor bijzondere momenten",
              body: "Laat een bestelling bezorgen voor een verjaardag, jubileum, geboorte, feestdag of andere speciale gelegenheid.",
            },
          ]}
        />
      </Block>
    </ContentPage>
  );
}
